module.exports = __webpack_public_path__ + "static/media/green-map-pin.f464a10b.svg";